
export const defaultConfiguration = {
    titleClosed: '点击聊天！',
    titleOpen: '我们聊聊吧！',
    closedStyle: 'chat', // button or chat
    closedChatAvatarUrl: '', // only used if closedStyle is set to 'chat'
    cookieExpiration: 1, // in days. Once opened, closed chat title will be shown as button (when closedStyle is set to 'chat')
    introMessage: '你好我们能为您做些什么？',
    autoResponse: '我们支持 24 小时在线服务哦',
    autoNoResponse: 'It seems that no one is available to answer right now. Please tell us how we can ' +
    'contact you, and we will get back to you as soon as we can.',
    placeholderText: '发送消息...',
    displayMessageTime: true,
    mainColor: '#1f8ceb',
    alwaysUseFloatingButton: false,
    desktopHeight: 450,
    desktopWidth: 370,
    visitorPronoun: '你',
    adminPronoun: "客服"
};



// WEBPACK FOOTER //
// ./src/widget/default-configuration.js